import React, { useState } from 'react';
import { Modal } from 'legacy_components/Modal';
import { request } from 'helpers/tools';

export const NotificationModal = ({ user, clickedClose }) => {
    const [notifications, setNotifications] = useState(user.data.notifications || []);
    
    const hasUnread = notifications.some(n => !n.is_read);
    const [showUnreadOnly, setShowUnreadOnly] = useState(hasUnread);

    const filteredNotifications = showUnreadOnly
        ? notifications.filter(n => !n.is_read)
        : notifications;

    const displayNotifications = hasUnread ? filteredNotifications : notifications;

    const ontopStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const bodyStyle = {
        maxHeight: '70vh',
        overflowY: 'auto',
        padding: '0.3rem',
        paddingTop: '0.6rem',
        paddingBottom: '0rem',
        width: '30rem',
    };

    const buttonBase = {
        backgroundColor: 'transparent',
        border: '1px solid #bbb',
        color: '#333',
        margin: 0,
        padding: '0.3rem 1rem',
        cursor: 'pointer',
    };

    const leftButton = {
        ...buttonBase,
        borderRadius: '6px 0 0 6px',
        borderRight: 'none',
        backgroundColor: showUnreadOnly ? '#eee' : 'transparent',
        color: showUnreadOnly ? '#000' : '#333',
    };

    const rightButton = {
        ...buttonBase,
        borderRadius: '0 6px 6px 0',
        backgroundColor: showUnreadOnly ? 'transparent' : '#eee',
        color: showUnreadOnly ? '#333' : '#000',
    };

    const toggleContainer = {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '0.5rem',
    };

    const blockStyle = {
        position: 'relative',
        backgroundColor: '#fff',
        padding: '0.75rem 1rem',
        marginBottom: '0.75rem',
        borderRadius: '8px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        borderLeft: '4px solid #ff4d4f',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25rem',
        wordBreak: 'break-word',
        transition: 'background-color 0.2s',
    };

    const blockReadStyle = {
        ...blockStyle,
        backgroundColor: '#f9f9f9',
        borderLeft: '4px solid #ccc',
    };

    const crossStyle = {
        position: 'absolute',
        top: '0.5rem',
        right: '0.5rem',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '1rem',
        border: '1px solid #ccc',
        color: '#3d3838ff',
        borderRadius: '50%',
        width: '1.5rem',
        height: '1.5rem',
        lineHeight: '1.2rem',
        textAlign: 'center',
        padding: 0,
        transition: 'background-color 0.2s',
    };

    const roleStyle = {
        position: 'absolute',
        top: '0.5rem',
        right: '2.5rem',
        fontSize: '0.75rem',
        color: '#666',
        backgroundColor: '#f0f0f0',
        padding: '0.1rem 0.4rem',
        borderRadius: '4px',
    };

    const headerStyle = {
        fontSize: '0.875rem',
        fontWeight: 600,
        color: '#555',
        marginBottom: '0.25rem',
    };

    // Translation map
    const roleTranslations = {
        clientuser: "Základní uživatel",
        maintenanceuser: "Obslužný uživatel",
        managementuser: "Schvalovací uživatel",
        accountantuser: "Účetní uživatel",
    };

    const translateRole = (role) => {
        if (!role) return null;
        const key = role.toLowerCase().replace(/\s+/g, ''); // normalize e.g. "Management user"
        return roleTranslations[key] || role; // fallback to original if unknown
    };

    const handleDismiss = async (id) => {
        const updatedNotifications = notifications.filter(n => n.id !== id);
        setNotifications(updatedNotifications);
        user.data.notifications = updatedNotifications;

        await request('/set_user_notifications/', 'POST', JSON.stringify({
            notifications: updatedNotifications.map(n => ({ ...n, is_read: true }))
        }));

        if (updatedNotifications.length === 0) {
            clickedClose();
        }
    };

    const handleClose = async () => {
        if (notifications.length > 0) {
            const payload = notifications.map(n => ({ ...n, is_read: true }));
            user.data.notifications = payload;
            await request('/set_user_notifications/', 'POST', JSON.stringify({ notifications: payload }));
        }
        clickedClose();
    };

    let onRoleChange = async (role) => {
        await request('/user/role/', 'POST', role).catch(err => console.log(err));
    };

    if (displayNotifications.length === 0) return null;

    return (
        <div style={ontopStyle}>
            <Modal name={`Upozornění`} close={handleClose}>
                <main style={bodyStyle}>
                    {hasUnread && notifications.length > 0 && (
                        <div style={toggleContainer}>
                            <button style={leftButton} onClick={() => setShowUnreadOnly(true)}>
                                Jen nepřečtené
                            </button>
                            <button style={rightButton} onClick={() => setShowUnreadOnly(false)}>
                                Zobrazit vše
                            </button>
                        </div>
                    )}

                    {displayNotifications.slice().reverse().map((notification) => {
                        const messageStyle = {
                            fontSize: '1rem',
                            lineHeight: 1.4,
                            color: '#222',
                            fontWeight: notification.is_read ? 'normal' : 'bold',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflow: 'hidden',
                        };

                        const uuidMatch = notification.docuuid || notification.message.match(/"([^"]+)"/)?.[1];
                        const combinedBlockStyle = notification.is_read ? { ...blockReadStyle } : { ...blockStyle };

                        const translatedRole = translateRole(notification.role);

                        return (
                            <div
                                key={notification.id}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgb(235, 195, 227)'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = notification.is_read ? blockReadStyle.backgroundColor : blockStyle.backgroundColor}
                                onClick={async () => {
                                    if (uuidMatch) {
                                        let roleToSend = notification.role;
                                        if (roleToSend && roleToSend.toLowerCase() === "managementuser" && notification.management_level) {
                                            roleToSend = `${roleToSend}${notification.management_level}`;
                                        }
                                        if (roleToSend) {
                                            await onRoleChange(roleToSend);
                                        }
                                        await handleClose();
                                        window.location.assign(`/my_documents/${uuidMatch}/general`);
                                    }
                                }}
                                style={{ ...combinedBlockStyle, cursor: uuidMatch ? 'pointer' : 'default' }}
                            >
                                <button
                                    style={crossStyle}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgb(178, 176, 189)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = ''}
                                    onClick={(e) => { e.stopPropagation(); handleDismiss(notification.id); }}
                                >
                                    ×
                                </button>

                                {(translatedRole || notification.management_level) && (
                                    <div style={roleStyle}>
                                        {translatedRole}
                                        {notification.management_level && (
                                            <> (Úr. {notification.management_level})</>
                                        )}
                                    </div>
                                )}

                                <div style={headerStyle}>
                                    {new Date(notification.created_at).toLocaleDateString('cs-CZ')} –{' '}
                                    {new Date(notification.created_at).toLocaleTimeString('cs-CZ', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    })}
                                </div>
                                <div style={messageStyle}>
                                    {notification.message}
                                </div>
                            </div>
                        );
                    })}
                </main>
            </Modal>
        </div>
    );
};
